import axios from 'axios';
import { getDomainOrigin, getAxiosConfig } from 'utils/serverConfig';
import { IMEIDetailsResponse } from './types';

export const verifyDevice = async (
    partnerId: string,
    serial_number: string,
    group: string
): Promise<IMEIDetailsResponse> => {
    try {
        const { data } = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/partner/${partnerId}/imei-detail?serial-number=${serial_number}&group_name=${group}`,
            ...getAxiosConfig(),
        });
        return {
            message: data.message,
            isValid: data.is_valid,
            modelDetails: {
                id: data?.model_details?.id,
                activationDate: data?.model_details?.activation_date,
                description: data?.model_details?.description,
                modelMappingName: data?.model_details?.model_mapping_name,
                name: data?.model_details?.name,
                price: data?.model_details?.price,
                type: data?.model_details?.type,
                brand: data?.model_details?.brand,
                showActivationDate:
                    data?.model_details?.show_activation_date ?? true,
            },
        };
    } catch (e: any) {
        if (e?.response?.status === 401) {
            return {
                isValid: false,
                message: e?.response?.data?.message,
            };
        }
        if (e?.response?.status === 400) {
            return {
                isValid: false,
                message: e?.response?.data?.message,
            };
        }
        return {
            isValid: false,
            message: e?.response?.data?.message,
        };
    }
};
